export default "__VITE_ASSET__DoNa8IS___"